module.exports = __webpack_public_path__ + "media/images/Stream-4258c20a.webp";